import {useMemo} from "react";

import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {useRecentFilters} from "../../search/hooks/use_recent_filters";
import {
    IPersonalizedLocationPrice,
    IPersonalizedPropertyCard,
    IPersonalizedRecentSearch,
    IPersonalizedRecommendationsTeaser
} from "../types/IPersonalizedHomepage";
import {getPersonalizedRecommendationsTeaser} from "../utils/get_personalized_recommendations_teaser";
import {mapRecentFiltersToPersonalized} from "../utils/map_recent_filters_to_personalized";
import {usePersonalizedHomematchRecommendations} from "./use_personalized_homematch_recommendations";
import {usePersonalizedLocationPrices} from "./use_personalized_location_prices";
import {usePersonalizedRecentlyViewedProperties} from "./use_personalized_recently_viewed_properties";

export interface IPersonalizedSectionState {
    isLoading: boolean;
    isError: boolean;
    isEmpty: boolean;
}

export interface IPersonalizedHomepageData {
    recentSearches: IPersonalizedRecentSearch[];
    recentSearchesState: IPersonalizedSectionState;
    locationPrices: IPersonalizedLocationPrice[];
    /** Latest `YYYY-MM` month carrying price data, for the card's footer note. */
    locationPricesLatestMonth: string | null;
    locationPricesState: IPersonalizedSectionState;
    recentlyViewedProperties: IPersonalizedPropertyCard[];
    /** Raw API payload behind the cards, needed for the `products[]` analytics payload. */
    recentlyViewedPropertyDetails: IPropertyDetail[];
    recentlyViewedPropertiesState: IPersonalizedSectionState;
    recommendationsTeaser: IPersonalizedRecommendationsTeaser;
    /** True when the Homematch buffer has pending preleads — the teaser CTA then opens the tinder deck. */
    hasHomematchRecommendations: boolean;
}

const RECENTLY_VIEWED_PROPERTIES_LIMIT = 8;

/**
 * Aggregates RP-775 data without adding work to the server-side data fetcher.
 * Existing browser history is read after mount and all dependent API calls are
 * therefore initiated only on the client.
 */
export const usePersonalizedHomepageData = (): IPersonalizedHomepageData => {
    const {recentFilters, isMounted: areRecentFiltersMounted} = useRecentFilters();
    const recentSearches = useMemo(() => mapRecentFiltersToPersonalized(recentFilters), [recentFilters]);
    const recentlyViewedPropertiesResult = usePersonalizedRecentlyViewedProperties(RECENTLY_VIEWED_PROPERTIES_LIMIT);
    const locationPricesResult = usePersonalizedLocationPrices({
        areRecentlyViewedPropertiesLoading: recentlyViewedPropertiesResult.isLoading,
        recentFilters,
        isRecentFiltersMounted: areRecentFiltersMounted,
        recentlyViewedPropertyDetails: recentlyViewedPropertiesResult.recentlyViewedPropertyDetails
    });
    const homematchRecommendations = usePersonalizedHomematchRecommendations();
    const recommendationsTeaser = useMemo(
        () =>
            getPersonalizedRecommendationsTeaser({
                homematchPreleads: homematchRecommendations.preleads,
                recentSearches,
                recentlyViewedProperties: recentlyViewedPropertiesResult.recentlyViewedProperties
            }),
        [homematchRecommendations.preleads, recentSearches, recentlyViewedPropertiesResult.recentlyViewedProperties]
    );

    return {
        recentSearches,
        recentSearchesState: {
            isLoading: !areRecentFiltersMounted,
            isError: false,
            isEmpty: areRecentFiltersMounted && recentSearches.length === 0
        },
        locationPrices: locationPricesResult.locationPrices,
        locationPricesLatestMonth: locationPricesResult.latestPricedMonth,
        locationPricesState: {
            isLoading: locationPricesResult.isLoading,
            isError: locationPricesResult.isError,
            isEmpty: locationPricesResult.isEmpty
        },
        recentlyViewedProperties: recentlyViewedPropertiesResult.recentlyViewedProperties,
        recentlyViewedPropertyDetails: recentlyViewedPropertiesResult.recentlyViewedPropertyDetails,
        recentlyViewedPropertiesState: {
            isLoading: recentlyViewedPropertiesResult.isLoading,
            isError: recentlyViewedPropertiesResult.isError,
            isEmpty: recentlyViewedPropertiesResult.isEmpty
        },
        recommendationsTeaser,
        hasHomematchRecommendations: homematchRecommendations.preleads.length > 0
    };
};
import {useMemo} from "react";

import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {useRecentFilters} from "../../search/hooks/use_recent_filters";
import {
    IPersonalizedLocationPrice,
    IPersonalizedPropertyCard,
    IPersonalizedRecentSearch,
    IPersonalizedRecommendationsTeaser
} from "../types/IPersonalizedHomepage";
import {getPersonalizedRecommendationsTeaser} from "../utils/get_personalized_recommendations_teaser";
import {mapRecentFiltersToPersonalized} from "../utils/map_recent_filters_to_personalized";
import {usePersonalizedHomematchRecommendations} from "./use_personalized_homematch_recommendations";
import {usePersonalizedLocationPrices} from "./use_personalized_location_prices";
import {usePersonalizedRecentlyViewedProperties} from "./use_personalized_recently_viewed_properties";

export interface IPersonalizedSectionState {
    isLoading: boolean;
    isError: boolean;
    isEmpty: boolean;
}

export interface IPersonalizedHomepageData {
    recentSearches: IPersonalizedRecentSearch[];
    recentSearchesState: IPersonalizedSectionState;
    locationPrices: IPersonalizedLocationPrice[];
    /** Latest `YYYY-MM` month carrying price data, for the card's footer note. */
    locationPricesLatestMonth: string | null;
    locationPricesState: IPersonalizedSectionState;
    recentlyViewedProperties: IPersonalizedPropertyCard[];
    /** Raw API payload behind the cards, needed for the `products[]` analytics payload. */
    recentlyViewedPropertyDetails: IPropertyDetail[];
    recentlyViewedPropertiesState: IPersonalizedSectionState;
    recommendationsTeaser: IPersonalizedRecommendationsTeaser;
    /** True when the Homematch buffer has pending preleads — the teaser CTA then opens the tinder deck. */
    hasHomematchRecommendations: boolean;
}

const RECENTLY_VIEWED_PROPERTIES_LIMIT = 8;

/**
 * Aggregates RP-775 data without adding work to the server-side data fetcher.
 * Existing browser history is read after mount and all dependent API calls are
 * therefore initiated only on the client.
 */
export const usePersonalizedHomepageData = (): IPersonalizedHomepageData => {
    const {recentFilters, isMounted: areRecentFiltersMounted} = useRecentFilters();
    const recentSearches = useMemo(() => mapRecentFiltersToPersonalized(recentFilters), [recentFilters]);
    const recentlyViewedPropertiesResult = usePersonalizedRecentlyViewedProperties(RECENTLY_VIEWED_PROPERTIES_LIMIT);
    const locationPricesResult = usePersonalizedLocationPrices({
        areRecentlyViewedPropertiesLoading: recentlyViewedPropertiesResult.isLoading,
        recentFilters,
        isRecentFiltersMounted: areRecentFiltersMounted,
        recentlyViewedPropertyDetails: recentlyViewedPropertiesResult.recentlyViewedPropertyDetails
    });
    const homematchRecommendations = usePersonalizedHomematchRecommendations();
    const recommendationsTeaser = useMemo(
        () =>
            getPersonalizedRecommendationsTeaser({
                homematchPreleads: homematchRecommendations.preleads,
                recentSearches,
                recentlyViewedProperties: recentlyViewedPropertiesResult.recentlyViewedProperties
            }),
        [homematchRecommendations.preleads, recentSearches, recentlyViewedPropertiesResult.recentlyViewedProperties]
    );

    return {
        recentSearches,
        recentSearchesState: {
            isLoading: !areRecentFiltersMounted,
            isError: false,
            isEmpty: areRecentFiltersMounted && recentSearches.length === 0
        },
        locationPrices: locationPricesResult.locationPrices,
        locationPricesLatestMonth: locationPricesResult.latestPricedMonth,
        locationPricesState: {
            isLoading: locationPricesResult.isLoading,
            isError: locationPricesResult.isError,
            isEmpty: locationPricesResult.isEmpty
        },
        recentlyViewedProperties: recentlyViewedPropertiesResult.recentlyViewedProperties,
        recentlyViewedPropertyDetails: recentlyViewedPropertiesResult.recentlyViewedPropertyDetails,
        recentlyViewedPropertiesState: {
            isLoading: recentlyViewedPropertiesResult.isLoading,
            isError: recentlyViewedPropertiesResult.isError,
            isEmpty: recentlyViewedPropertiesResult.isEmpty
        },
        recommendationsTeaser,
        hasHomematchRecommendations: homematchRecommendations.preleads.length > 0
    };
};
